export const exportOrder = [
  {
    path: `/ExportOrder`,
    name: `ExportOrder`,
    redirect: `/exportOrder/export/:projectId`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/exportOrder/export/:projectId',
        name: 'exportOrder/export',
        component: () => import('@/views/exportorder/ExportOrder')
      }
    ]
  }
];
